import api from '../api';

export const getLedgerEntriesByEntity = (entity) => {
  return api.post(`/ledgerEntriesByEntity`, entity);
};
